<template>
  <b-modal
    v-model="show"
    hide-footer
    hide-header
    centered
    size="xl"
    no-close-on-esc
    no-close-on-backdrop
  >
    <transition-group
      name="slide-next"
      tag="div"
      class="tabcontainer"
    >
      <div
        class="row align-items-center tabitem"
        v-if="step === 1"
        key="1"
      >
        <div class="col-6">
          <b-img
            :src="welcome"
            fluid
            class="p-5"
          />
        </div>
        <div class="col-6">
          <div>
            <h4 class="card-title">Herzlich Willkommen bei Carlisting!</h4>
            <p class="card-subtitle mb-2 text-muted">Ihre personalisierte Autohaus Website ist nur noch ein paar Klicks entfernt...</p>
            <b-list-group
              flush
              class="mt-3"
            >
              <b-list-group-item>
                <b-icon
                  variant="success"
                  icon="check-circle"
                  font-scale="1.5"
                  class="mr-2"
                />Optimale Darstellung und Detailansicht Ihrer Fahrzeuge
              </b-list-group-item>
              <b-list-group-item>
                <b-icon
                  variant="success"
                  icon="check-circle"
                  font-scale="1.5"
                  class="mr-2"
                />Wir importieren Ihren Bestand von AutoScout24 oder mobile.de
              </b-list-group-item>
              <b-list-group-item>
                <b-icon
                  variant="success"
                  icon="check-circle"
                  font-scale="1.5"
                  class="mr-2"
                />Alle Kaufanfragen erhalten Sie direkt per E-Mail
              </b-list-group-item>
              <b-list-group-item>
                <b-icon
                  variant="success"
                  icon="check-circle"
                  font-scale="1.5"
                  class="mr-2"
                />SEO optimiert und Full-Responsive für alle Endgeräte
              </b-list-group-item>
              <b-list-group-item>
                <b-icon
                  variant="success"
                  icon="check-circle"
                  font-scale="1.5"
                  class="mr-2"
                />Per Iframe überall einbinden & Domain-Verknüpfung möglich
              </b-list-group-item>
              <b-list-group-item>
                <b-icon
                  variant="success"
                  icon="check-circle"
                  font-scale="1.5"
                  class="mr-2"
                />Flexibel: monatlich kündbar, nur 14,99€
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </div>

      <div
        class="row align-items-center"
        style="height: 600px"
        v-if="step === 2"
        key="2"
      >
        <div class="col-6">
          <b-img
            :src="sync"
            fluid
            class="p-5"
          />
        </div>

        <div class="col-6">
          <h4 class="card-title">Autobörse als Quelle verknüpfen</h4>
          <p class="text-muted">Wir importieren Ihren Fahrzeugbestand von der gewünschten Autobörse auf Ihre neue Website. Der Bestand wird täglich und automatisch aktualisiert.</p>

          <p>Bitte wählen Sie Ihre Quelle aus:</p>

          <div class="row justify-content-center">
            <b-button-group class="col-12">
              <b-button
                :variant="selectedSource === 'as24' ? 'primary' : 'outline-primary'"
                @click="selectSource('as24')"
              >AutoScout24</b-button>
              <b-button
                :variant="selectedSource === 'mobileDe' ? 'primary' : 'outline-primary'"
                @click="selectSource('mobileDe')"
              >mobile.de</b-button>
            </b-button-group>
          </div>
          <b-form-invalid-feedback :state="validateSelectedSource">Bitte wählen Sie eine Quelle aus.</b-form-invalid-feedback>

          <div
            class="mt-3"
            v-if="selectedSource === 'mobileDe'"
          >
            <b-form-group
              label="mobile.de Kundennummer:"
              label-for="input-1"
              description="Sie finden Ihre Kundennummer im mobile.de Händlerbereich."
            >
              <b-form-input
                :state="validation"
                v-model="mobileDeId"
                type="text"
                required
                placeholder="z.B. 249123145"
              ></b-form-input>
              <b-form-invalid-feedback :state="validation">Bitte geben Sie eine Kundennummer an.</b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div
            class="mt-3"
            v-else-if="selectedSource === 'as24'"
          >
            <b-form-group
              label="AutoScout24 Kundennummer:"
              label-for="input-1"
              description="Sie finden Ihre Kundennummer im AutoScout24 Händlerbereich."
            >
              <b-form-input
                :state="validation"
                v-model="as24Id"
                type="text"
                required
                placeholder="z.B. 249123145"
              ></b-form-input>
              <b-form-invalid-feedback :state="validation">Bitte geben Sie eine Kundennummer an.</b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div
            v-else
            style="height: 125px"
          />

          <b-alert :show="selectedSource">
            <b-icon
              icon="info-fill"
              font-scale="1.5"
              class="mr-3"
            />Zu Demo-Zwecken werden zunächst nur 5 Fahrzeuge importiert.
          </b-alert>

          <b-alert
            variant="danger"
            :show="errorMessage.length > 0"
          >
            <b-icon
              icon="alert-triangle-fill"
              font-scale="1.5"
              class="mr-3"
            />
            {{errorMessage}}
          </b-alert>
        </div>

        <div
          class="col-12"
          style="min-height: 16px"
        >
          <b-progress
            :value="progress"
            v-if="progress > 0"
          ></b-progress>
        </div>
      </div>

      <div
        class="row align-items-center"
        style="height: 600px"
        v-if="step === 3"
        key="3"
      >
        <div class="col-12 row justify-content-center">
          <h4 class="card-title col-12 text-center">Ihre Autohaus Website wurde erfolgreich erstellt!</h4>
          <p class="text-muted col-6 text-center">
            Unter „Website anpassen“ haben Sie viele Möglichkeiten Ihre Seite zu personalisieren, z.B. mit eigenem Farbschema. Sie sehen bereits 5 Ihrer Fahrzeuge zur Vorschau. Sobald Sie ein Abonnement gebucht haben, wird Ihr kompletter Bestand angezeigt.
          </p>
          <div class="col-12 text-center">
            <b-img
              :src="complete"
              height="240"
            />
          </div>
        </div>
      </div>
    </transition-group>

    <div class="w-100 d-flex flex-row-reverse align-self-end position-relative">
      <div class="col d-flex align-items-center justify-content-center stepper">
        <div
          class="step-indicator"
          v-for="index in 3"
          :key="index"
          :class="{'bg-primary': index <= step}"
        />
      </div>
      <b-button
        variant="primary"
        @click="nextStep()"
        :disabled="loading"
      >Weiter</b-button>
      <!--       <b-button
        variant="primary"
        @click="prevStep()"
        v-if="step > 1"
      >Zurück (dev only)</b-button> -->
    </div>
  </b-modal>
</template>

<script>
import authorizeAs24, { AuthorizationCanceledError } from '@/util/authorizeAs24';
import complete from '@/assets/complete.png';
import welcome from '@/assets/welcome.png';
import sync from '@/assets/sync.png';


export default {
  name: 'WelcomeModal',
  props: ['value'],
  mixins: [authorizeAs24],
  data: () => ({
    step: 1,
    mobileDeId: '',
    as24Id: '',
    progress: 0,
    progressMessage: '',
    validation: null,
    validateSelectedSource: null,
    errorMessage: '',
    selectedSource: null,
    loading: false,
    complete,
    welcome,
    sync,
  }),

  computed: {
    show: {
      get () {
        return this.value;
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
  },

  methods: {
    prevStep () {
      this.step -= 1;
    },
    nextStep () {
      switch (this.step) {
        case 1:
          this.step += 1;
          break;
        case 2:
          this.setup();
          break;
        case 3:
          this.show = false;
          break;
      }

    },
    selectSource (source) {
      this.validateSelectedSource = null;
      this.selectedSource = source;
    },
    async setup () {

      this.validateSelectedSource = !!this.selectedSource;
      if (!this.validateSelectedSource) return;

      try {
        if (this.selectedSource === "mobileDe") {
          this.validation = this.mobileDeId.length > 0;
          if (!this.validation) return;
          await this.$store.dispatch('auth/updateUser', { mobileDeId: this.mobileDeId });
        } else {
          this.validation = this.as24Id.length > 0;
          if (!this.validation) return;

          await this.authorizeAs24();
          await this.$store.dispatch('auth/updateUser', { as24Id: this.as24Id });
        }


        this.progress = 25;
        await this.$axios.get("/import/imprint");

        await this.$axios.get("/import/dealerData");
        await this.$store.dispatch('auth/getUser');
        this.progress = 50;

        await this.$axios.get("/import/vehicles?limit=5");
        this.progress = 100;

        this.step = 3;

      } catch (error) {
        if (error instanceof AuthorizationCanceledError) {
          this.errorMessage = 'Das erneute Verbinden der Datenquelle wurde abgebrochen';
          return;
        }
        const text =
          (error.response && error.response.data && error.response.data.errorLocalized)
            ? error.response.data.errorLocalized
            : 'Es ist ein Fehler aufgetreten';

        this.errorMessage = text;
      }
    },
  },

}
</script>

<style scoped>
.tabcontainer {
  height: 600px;
  position: relative;
  min-height: 100%;
  width: 100%;
  overflow: hidden;
}
.tabitem {
  position: absolute;
  width: 100%;
  height: 100%;
}
.slide-next-leave-active,
.slide-next-enter-active,
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: 1s;
}
.slide-next-enter,
.slide-next-leave,
.slide-prev-leave-to {
  transform: translate(100%, 0);
}

.slide-next-leave-to,
.slide-prev-enter,
.slide-prev-leave {
  transform: translate(-100%, 0);
}

.stepper {
  position: absolute;
  top: 50%;
}
.step-indicator {
  background-color: #6c757d;
  width: 30px;
  height: 3px;
  margin: 0 5px;
}
.b-icon {
  vertical-align: middle;
}
</style>